import { BaSeParagraph, BaSeTheme } from '@base/react';
import React from 'react';

function ModalConfirm({ tipo }) {
  const renderConteudo = () => {
    switch (tipo) {
      case 1:
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae30}
            >
              Você está prestes a acessar a{' '}
              <strong>entrevista de seleção do Empretec Urbano,</strong>{' '}
              conduzida por uma inteligência artificial especializada na
              metodologia Empretec.
            </BaSeParagraph>

            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae30}
            >
              A entrevista é{' '}
              <strong>online, gratuita e composta por 5 perguntas,</strong>{' '}
              baseadas nas suas experiências profissionais, empresariais ou
              pessoais.
            </BaSeParagraph>

            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae30}
            >
              Antes de seguir:
            </BaSeParagraph>

            <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
              <p style={{ fontSize: 40 }}>.</p>
              <BaSeParagraph
                color={BaSeTheme.colors.institucionais.cinzaSebrae30}
              >
                <strong>Reserve cerca de 50 minutos,</strong> em um ambiente{' '}
                <strong>tranquilo e sem distrações,</strong> para garantir foco
                total.
              </BaSeParagraph>
            </div>

            <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
              <p style={{ fontSize: 40 }}>.</p>
              <BaSeParagraph
                color={BaSeTheme.colors.institucionais.cinzaSebrae30}
              >
                <strong>Reflita sobre sua trajetória</strong> — seus acertos,
                erros e aprendizados —, pois isso vai ajudar a trazer{' '}
                <strong>exemplos reais e relevantes.</strong>
              </BaSeParagraph>
            </div>

            <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
              <p style={{ fontSize: 40 }}>.</p>
              <BaSeParagraph
                color={BaSeTheme.colors.institucionais.cinzaSebrae30}
              >
                Responda com{' '}
                <strong>clareza, objetividade e boa estrutura.</strong>
              </BaSeParagraph>
            </div>

            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae30}
            >
              Ao seguir para a entrevista, você demonstra compromisso com seu
              desenvolvimento pessoal e profissional.
            </BaSeParagraph>

            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae30}
            >
              Se optar por preencher depois ou continuar a entrevista,
              enviaremos um link por e-mail para você acessar quando quiser.
            </BaSeParagraph>
          </div>
        );

      case 2:
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae30}
            >
              Você está prestes a acessar o questionário de autoavaliação, que
              ajudará a entender o perfil do seu negócio inovador. Essa etapa é
              obrigatória para sua participação no Empretec Startup.
            </BaSeParagraph>
          </div>
        );

      case 3:
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae30}
            >
              Você está prestes a acessar a{' '}
              <strong>entrevista de seleção do Empretec Arena,</strong>{' '}
              conduzida por uma inteligência artificial especializada na
              metodologia Empretec.
            </BaSeParagraph>

            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae30}
            >
              A entrevista é{' '}
              <strong>online, gratuita e composta por 5 perguntas,</strong>{' '}
              baseadas nas suas experiências profissionais, empresariais ou
              pessoais.
            </BaSeParagraph>

            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae30}
            >
              Antes de seguir:
            </BaSeParagraph>

            <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
              <p style={{ fontSize: 40 }}>.</p>
              <BaSeParagraph
                color={BaSeTheme.colors.institucionais.cinzaSebrae30}
              >
                <strong>Reserve cerca de 50 minutos,</strong> em um ambiente{' '}
                <strong>tranquilo e sem distrações,</strong> para garantir foco
                total.
              </BaSeParagraph>
            </div>

            <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
              <p style={{ fontSize: 40 }}>.</p>
              <BaSeParagraph
                color={BaSeTheme.colors.institucionais.cinzaSebrae30}
              >
                <strong>Reflita sobre sua trajetória</strong> — seus acertos,
                erros e aprendizados —, pois isso vai ajudar a trazer{' '}
                <strong>exemplos reais e relevantes.</strong>
              </BaSeParagraph>
            </div>

            <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
              <p style={{ fontSize: 40 }}>.</p>
              <BaSeParagraph
                color={BaSeTheme.colors.institucionais.cinzaSebrae30}
              >
                Responda com{' '}
                <strong>clareza, objetividade e boa estrutura.</strong>
              </BaSeParagraph>
            </div>

            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae30}
            >
              Ao seguir para a entrevista, você demonstra compromisso com seu
              desenvolvimento pessoal e profissional.
            </BaSeParagraph>

            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae30}
            >
              Se optar por preencher depois ou continuar a entrevista,
              enviaremos um link por e-mail para você acessar quando quiser.
            </BaSeParagraph>
          </div>
        );

      case 4:
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae30}
            >
              Após registrar seu interesse, nossa equipe poderá entrar em
              contato para orientar sobre as próximas etapas do Empretec Rural.
            </BaSeParagraph>
          </div>
        );

      default:
        return null;
    }
  };

  return <>{renderConteudo()}</>;
}

export default ModalConfirm;
